// E-commerce Store Tour
// Stores, products, collections, inventory and checkout
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_sites); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const ecommerceTour = {
  id: 'ecommerce',
  name: 'E-commerce Store Tour',
  displayName: 'Sell Products Online',
  description: 'Stores, products, collections, inventory and checkout',
  estimatedDuration: '4 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_sites',
      popover: {
        title: "🛒 Welcome to Your Store",
        description: `
          A **store** turns your product catalog into a browsable shop with a checkout — connected to the same contacts, automations, and reporting as everything else.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📦 Products First",
        description: `
          Everything you sell starts as a **product**: name, price, description, images, and variants for options like size or tier. Recurring products create subscriptions when they sell.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🗂️ Collections",
        description: `
          Group related products into **collections** so customers can browse by category instead of scrolling one long list.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📊 Inventory",
        description: `
          Track stock so you stop selling what you do not have. Inventory that reflects reality prevents the worst customer experience: a paid order you cannot fulfil.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "💳 Checkout",
        description: `
          Checkout needs a connected **payment gateway**. Keep the form short — every extra field costs conversions — and make sure it works on a phone.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔄 Recover Abandoned Carts",
        description: `
          Shoppers who start and stop are your warmest audience. **Abandoned checkouts** captures them; pair it with an automation and you recover real revenue.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📈 After the Sale",
        description: `
          Purchases attach to the contact, so you can automate delivery follow-up, review requests, and win-back campaigns segmented by what they bought.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your Store Is Live",
        description: `
          You can now:

✅ Build products and collections
✅ Track inventory
✅ Take payment at checkout
✅ Recover abandoned carts and follow up

**Next:** publish one product and buy it yourself to test the whole path.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
